//import Echo from "laravel-echo";

require('./bootstrap')
import axios from 'axios'
import VueAxios from 'vue-axios'

import Vue from 'vue'
import VueMoment from 'vue-moment'

import stringSimilarity from 'string-similarity'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { missingFieldErrorText, vehicleMotorhomeRegex, resetVehicleWithError } from "./common/vehicleMethods"

Bugsnag.start({
    apiKey: 'c1f4a51cc15b5f6c550d54411ca3648f',
    plugins: [new BugsnagPluginVue()],
    releaseStage: process.env.NODE_ENV,
    onError: function(e) {
        if(window.localStorage.vuex) {
            e.addMetadata('localstorage', {
                vuex: JSON.parse(window.localStorage.vuex),
            })
        } else {
            e.addMetadata('localstorage', {
                vuex: 'not available',
            })
        }
        // temp implement to solve bugsnag coupon.toUpperCase issue
        if(window.coupon) {
            e.addMetadata('coupon', {
                coupon: window.coupon,
            })
        }
    }
})

const bugsnagVue = Bugsnag.getPlugin('vue')
window.bugsnag = Bugsnag;
bugsnagVue.installVueErrorHandler(Vue)

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

// Axios
axios.defaults.headers.common['x-api-key'] = process.env.MIX_API_KEY
window.axios = axios

Vue.use(VueAxios, axios)
Vue.use(VueMoment)

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import './vee-validate-rules'
//import './nav'

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

Vue.mixin({
	methods: {
        parseAxiosErrors(error) {

            const errorDetails = {
                url: error.config?.url,
                method: error.config?.method,
                requestData: error.config?.data,
            };

            if (error.response) {
                Object.assign(errorDetails, {
                    status: error.response.status,
                    responseData: error.response.data,
                    headers: error.response.headers,
                });
            } else if (error.request) {
                Object.assign(errorDetails, { request: error.request });
            } else {
                Object.assign(errorDetails, { message: error.message });
            }

            return errorDetails;
        },
        validateAdditionalPeopleInput(person, accountHolderPhoneNumber) {

            const phonePattern = /^07\d{9}$/;

            if(!person.name || !person.surname) {
                return {
                    valid: false,
                    errorMsg: "Invalid name in Additional Members",
                    type: 'noName'
                }
            }

            if (!person.phone) {
                return {
                    valid: false,
                    errorMsg: "No phone number",
                    type: 'noPhone'
                }
            }

            if(!phonePattern.test(person.phone)) {
                return {
                    valid: false,
                    errorMsg: "Invalid Phone Number in Additional Members",
                    type: 'invalidNumber'
                }
            }

            if (person.phone == accountHolderPhoneNumber) {
                return {
                    valid: false,
                    errorMsg: "Additional Members phone number is the same as account holder",
                    type: 'sameNumberAsAccountHolder'
                }
            }

            return {
                valid: true,
                errorMsg: "Success",
                type: 'success'
            }

        },
		apiCreatePartialQuote(data) {
			return this.$http
				.post(window.apiUrl + '/partquote', data)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
		async apiCreateQuote(data) {
			return this.$http
				.post(window.apiUrl + '/quote', data)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
                    return { status: 'error', message: e.response.data.message };
				})
		},
		apiUpdateQuote(data) {
			return this.$http
				.patch(window.apiUrl + '/quote/' + data.quote.id, data)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},

		apiUpdatePartialQuote(data) {
            return this.$http
				.patch(window.apiUrl + '/quote/' + data.quote.id + '/partial', data)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
        apiUpdateCurrentSplitTestStep(stepValue) {
            if (!window.splitId || !stepValue) return

            const data = {
                split_id: window.splitId,
                flow_step: stepValue,
            }

            return this.$http
                .post(window.apiUrl + '/split-test/current-step', data)
                .then((r) => {
                    return r.data
                })
                .catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
                    return null
                })
        },
		apiGetQuote(quoteId) {
			return this.$http
				.get(window.apiUrl + '/quote/' + quoteId)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
		apiGetVehicle(vrm) {
            if(vrm.length > 15)
            {
                return null;
            }
			return this.$http
				.get(window.apiUrl + '/vrm/' + vrm)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed Vehicle'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
		apiGetAddress(postcode) {
			return this.$http
				.get(window.apiUrl + '/postcode/' + postcode)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed Postcode'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
		apiGetServices(data) {
			return this.$http
				.get(window.apiUrl + '/services')
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
		async getAddresses(postcode) {
            const result = await this.apiGetAddress(postcode)

            if (!result || !result.status) {
                Bugsnag.notify(new Error("Postcode API Lookup Failed"), (event) => {
                    event.severity = "warning";
                    event.addMetadata("details", { reason: result ?? "No result data available", postcode: postcode ?? "Unknown" });
                })
                return null
            }
            return result
        },
        async getVehicle(vrm) {
            const result = await this.apiGetVehicle(vrm)
            if (!result || !result.status) {
                Bugsnag.notify(new Error("Vehicle API Lookup Failed"), (event) => {
                    event.severity = "warning";
                    event.addMetadata("details", { reason: result ?? "No result data available", vrm: vrm ?? "Unknown" });
                })
                return null
            }
            return result
            //return {"make":"LEXUS","model":"CT 200H ADVANCE CVT","year":"2016","fuel":"HYBRID ELECTRIC","transmission":"CVT","firstRegistered":null,"colour":null}
        },
        async updateAdditionalPeopleApi(formData, quoteId) {
            let apiUrl = '/api/quote/'+quoteId+'/update-people'
            let res = await this.$http.post(window.baseUrl + apiUrl, formData)
            return res

        },
        async removePersonFromQuoteApi(formData, quoteId) {
            let apiUrl = '/api/quote/'+quoteId+'/remove-people-quote'
            let res = await this.$http.post(window.baseUrl + apiUrl, formData)
            return res

        },
        async lookupPostcode(targetAddress = this.form.address, targetPostcodeRef = 'postcode', componentRef = null) {
            targetAddress.manual = false

            let postcodeRef;
            if(componentRef){
                postcodeRef = this.$refs[componentRef].$refs[targetPostcodeRef]
            } else {
                postcodeRef = this.$refs[targetPostcodeRef];
            }

            if (!targetAddress.postcode.value) {
                return postcodeRef ? postcodeRef.validate() : null
            }

            const results = await this.getAddresses(targetAddress.postcode.value)

            if (results && results.addressList) {
                targetAddress.results = results.addressList.map((item, key) => {
                    return {
                        ...item,
                        value: key,
                        label: item.SummaryAddress,
                    }
                })
            } else {
                if (postcodeRef) {
                    postcodeRef.errors = ['Postcode not found. Please manually enter your address below.']
                }
                targetAddress.manual = true;
            }
        },
        selectAddress(targetAddress = this.form.address) {
            const address = targetAddress.results.find((item) => {
                return item.value === targetAddress.value
            })

            let addressPieces = address.FormattedAddressLines,
                addressComponents = address.ComponentParts,
                line1 = '',
                line2 = '',
                line3 = '',
                streetLine = ''

            if (addressPieces.Premises) {
                streetLine = addressPieces.Premises
            }
            if (addressPieces.Street) {
                streetLine += ' ' + addressPieces.Street
            }

            if (addressPieces.Organisation) {
                line1 = addressPieces.Organisation
                line2 = streetLine
            } else {
                line1 = streetLine
            }

            targetAddress.line1.value = line1
            targetAddress.line2.value = line2
            targetAddress.line3.value = line3

            if (addressPieces.PostTown) {
                if (addressPieces.Locality) {
                    targetAddress.town.value =
                        addressPieces.Locality + ', ' + addressPieces.PostTown
                } else {
                    targetAddress.town.value = addressPieces.PostTown
                }
            }

            if (addressPieces.Postcode) {
                targetAddress.postcode.value = addressPieces.Postcode.toUpperCase()
            }
            if (addressPieces.County) {
                targetAddress.county.value = addressPieces.County.toLowerCase()
            }
        },
        toggleManualAddress(targetAddress) {
            if (!Array.isArray(targetAddress.results)) {
                targetAddress.results = [];
            }

            if (targetAddress.manual) {
                const newAddress = {
                    value: targetAddress.results.length || 0,
                    label: `${targetAddress.line1.value},
                            ${targetAddress.town.value},
                            ${targetAddress.postcode.value || ''}`,
                            FormattedAddressLines: {
                                Premises: targetAddress.line1.value,
                                Street: targetAddress.line2.value,
                                Organisation: targetAddress.line3.value,
                                PostTown: targetAddress.town.value,
                                Postcode: targetAddress.postcode.value || '',
                                County: targetAddress.county.value,
                            },
                };
                targetAddress.results.push(newAddress);
                targetAddress.value = newAddress.value;
            }
            targetAddress.manual = !targetAddress.manual;
        },
        toggleManualVehicle(key, cantFindVehicle = false) {
            let form = this.form.vehicles;
            for(let i = 0; i < form.length; i++) {
                if (form[i].make.value == null && !cantFindVehicle) {
                    this.removeVehicle(i)
                }
            }
            // Toggle manual field
            this.form.vehicles = this.form.vehicles.map((vehicle, index) => {
                // adding vehicle or editing another vehicle will toggle manual vehicle form so avoid resetting error if we have missing vehicle info
                const missingFields = !vehicle.vrm.value || !vehicle.make.value || !vehicle.model.value || !vehicle.year.value;
                if(missingFields && !(vehicle.vrm.error !== "Can't find this vehicle" || vehicle.vrm.error !== 'Please enter a valid vehicle registration')) {
                    vehicle.manual = true
                    vehicle.hidden = false
                    return vehicle
                }

                if (index === key) {
                    vehicle.vrm.error = null
                    vehicle.manual = !vehicle.manual;
                    vehicle.hidden = !vehicle.manual;

                } else if(!(vehicle.vrm.error !== "Can't find this vehicle" || vehicle.vrm.error !== 'Please enter a valid vehicle registration')) {
                    vehicle.manual = false;
                    vehicle.hidden = true;
                }
                return vehicle;
            });
        },
        async lookupVrm(formVehicle, key) {
            let vehicleVrm = formVehicle?.vrm?.value?.trim();
            if (!vehicleVrm) {
                let newFormVehicle = formVehicle
                newFormVehicle.vrm.error = 'Reg number is required.'
                this.form.vehicles.splice(key, 1, newFormVehicle)
                return
            }

            if (vehicleVrm.length > 15) {
                let newFormVehicle = formVehicle
                newFormVehicle.vrm.error = 'Reg number is too long';
                this.form.vehicles.splice(key, 1, newFormVehicle)
                return
            }
            formVehicle.lookedUp = true
            if (
                this.form.vehicles.find((item, index) => {
                    if (!item.result) {
                        return false
                    }
                    return item.result.vrm === vehicleVrm && (key !== index)
                })
            ) {
                let newFormVehicle = formVehicle
                newFormVehicle = resetVehicleWithError('This vehicle has already been added.', newFormVehicle)
                this.form.vehicles.splice(key, 1, newFormVehicle)
                return false
            }
            let newFormVehicle = formVehicle
            newFormVehicle.manual = false
            const result = await this.getVehicle(vehicleVrm)
            if (!result || result.status === 'error') {
                newFormVehicle = resetVehicleWithError("Can't find this vehicle", newFormVehicle)
                this.form.vehicles.splice(key, 1, newFormVehicle)
                return
            }

            newFormVehicle.vrm.error = null

            // Append full result for Vehicle Card
            let vehicle = result.vehicle
            newFormVehicle.hidden = true
            if((!vehicle.make || !vehicle.model || !vehicle.year) && !vehicleMotorhomeRegex(vehicle) && !this.isVan(vehicle) && !this.isHeavy(vehicle) && !this.isVehicleATaxi(vehicle)) {
                // generate missing fields error message
                newFormVehicle.vrm.error = missingFieldErrorText(vehicle);
                // auto open vehicle form if any fields are missing for validation/allow user to automatically enter
                newFormVehicle.manual = true
                newFormVehicle.hidden = false
            }
            vehicle.uvd_api_log = result.apiLogId
            newFormVehicle.result = vehicle
            newFormVehicle.result.vrm = vehicleVrm
            // But also init other fields so the input are filled if user switches to manual
            newFormVehicle = {
                ...newFormVehicle,
                make: {value: vehicle.make},
                model: {value: vehicle.model},
                //colour: {value: vehicle.colour},
                year: {value: vehicle.year},
                class: {value: vehicle.class},
                parts_exclude: formVehicle.parts_exclude ? formVehicle.parts_exclude : "",
            }
            this.form.vehicles.splice(key, 1, newFormVehicle)

        },
        initVehicles(setLookedUpToTrue = false) {
            if (this.vehicles.length) {
                let countLoop = 1
                this.vehicles.forEach((vehicle) => {
                    // If: to counter when user drops no of vehicles on toggle page, but originally added more vrms.
                    if (countLoop <= this.quote.no_vehicles) {
                        this.form.vehicles.push({
                            result: vehicle,
							vrm: { value: vehicle.vrm },
							make: { value: vehicle.make },
							model: { value: vehicle.model },
							year: { value: vehicle.year },
                            parts_exclude: false,
                            hidden: true,
                            // Setting lookedUp to true on the details page (details.js)
                            // We don't want to trigger lookupAll() if the VRM hasn't changed on submit.
                            ...(setLookedUpToTrue ? { lookedUp: true } : {})
                        })
                    }

                    countLoop++
                })
            }

            let vehiclecount = 0
            if (this.vehicles.length) {
                vehiclecount = this.vehicles.length
            }

            for (let i = vehiclecount; i < this.quote.no_vehicles; i++) {
                this.form.vehicles.push({
                    class: { value: null},
                    make: { value: null},
                    model: { value: null },
                    vrm: {value: null},
                    year: { value: null }
                })
            }
        },
        initDays() {
            for (let i = 1; i <= 31; i++) {
                this.form.dateOfBirth.day.options.push({
                    value: i,
                    label: i,
                })
            }
        },
        initYears() {
            const currentYear = parseInt(this.$moment().format('YYYY'))
            for (let i = currentYear - 16; i >= 1900; i--) {
                this.form.dateOfBirth.year.options.push({
                    value: i,
                    label: i,
                })
            }
        },
        initMonths() {
            this.form.dateOfBirth.month.options = [
                {value: 1, label: 'January'},
                {value: 2, label: 'February'},
                {value: 3, label: 'March'},
                {value: 4, label: 'April'},
                {value: 5, label: 'May'},
                {value: 6, label: 'June'},
                {value: 7, label: 'July'},
                {value: 8, label: 'August'},
                {value: 9, label: 'September'},
                {value: 10, label: 'October'},
                {value: 11, label: 'November'},
                {value: 12, label: 'December'},
            ]
        },
        initStartDate() {
            if (this.policy_start_date) {
                this.form.startDate.value = this.$moment(this.policy_start_date).format(
                    'YYYY-MM-DD'
                )
            } else {
                this.form.startDate.value = this.$moment().format('YYYY-MM-DD')
            }

            this.form.startDate.min = this.$moment().format('YYYY-MM-DD')
            this.form.startDate.max = this.$moment()
                .add(120, 'days')
                .format('YYYY-MM-DD')

            this.form.startDate.datepickerState = {
                disabledDates: {
                    to: this.$moment()
                        .subtract(1, 'day')
                        .toDate(),
                    from: this.$moment()
                        .add(121, 'days')
                        .toDate(),
                },
            }
        },
        prepareCustomerData() {

            let data = {
                firstname: this.form.name.value,
                surname: this.form.surname.value,
                email: this.form.email.value,
                phone: this.form.phone.value,
                postcode: this.form.address.postcode.value,
                address_line_1: this.form.address.line1.value,
                address_line_2: this.form.address.line2.value,
                address_line_3: this.form.address.line3.value,
                county: this.form.address.county.value,
                consent_privacy: 1,
            }

            data.city = this.form.address.town.value ? this.form.address.town.value.toLowerCase() : this.form.address.town.value;



            if (this.form.dateOfBirth) {
                let year = this.form.dateOfBirth.year.value + ''

                let month = this.form.dateOfBirth.month.value + ''
                month = month.padStart(2, '0')

                let day = this.form.dateOfBirth.day.value + ''
                day = day.padStart(2, '0')

                data.dob = year + '-' + month + '-' + day

            }

			if (this.form.emailOffers) {
				data.consent_email = this.form.emailOffers.value
			}
			if (this.form.phoneOffers) {
				data.consent_phone = this.form.phoneOffers.value
			}
			return data
		},

        prepareBusinessAccountData() {
            return {
                name: this.form.businessName.value,
                named_contact: this.form.named_contact.value,
                purpose: this.form.businessPurpose.value,
                vat_number: this.form.vat_number.value,
            }
        },

        prepareBusinessAddressesData() {
            let addresses = []

            let mainAddress = {
                postcode: this.form.address.postcode.value,
                line_1: this.form.address.line1.value,
                line_2: this.form.address.line2.value,
                line_3: this.form.address.line3.value,
                type: 'PRIMARY', // has to be equal to App\Models\BusinessAddress::TYPE_PRIMARY
            }

            mainAddress.town = this.form.address.town.value ? this.form.address.town.value.toLowerCase() : this.form.address.town.value;


            addresses.push(mainAddress)

            // If the billing address does not differ from the main one, end here
            if (!this.form.billingAddressIsDifferent.value) {
                return addresses
            }

            let billingAddress = {
                postcode: this.form.billingAddress.postcode.value,
                line_1: this.form.billingAddress.line1.value,
                line_2: this.form.billingAddress.line2.value,
                line_3: this.form.billingAddress.line3.value,
                type: 'BILLING', // has to be equal to App\Models\BusinessAddress::TYPE_BILLING
            }

            billingAddress.town = this.form.billingAddress.town.value ? this.form.billingAddress.town.value.toLowerCase() : this.form.billingAddress.town.value;


            addresses.push(billingAddress)

            return addresses

        },

		async getQuotePrice(quote) {
			this.loadingPrice = true
            const result = await this.apiGetCalculation(quote.id, quote)
			this.loadingPrice = false
			if (!result) {
				//todo: manage error
				return
			}

            if (typeof this.preDiscountPrice !== 'undefined') {
                if (result && result.pre_discount) {
                    this.preDiscountPrice = result.pre_discount
                }
            }

            if (this.isBusinessFlow()) {
                var vatExclusivePrice = 0;
                var totalPrice = 0;
                if(this.isTermMonthly())
                {
                    vatExclusivePrice = this.getVatExclusivePrice(result.total_price_monthly)
                    totalPrice = result.total_price_monthly;
                }
                else
                {
                    vatExclusivePrice = this.getVatExclusivePrice(result.total_price)
                    totalPrice = result.total_price;
                }

                if (typeof this.vatAmount !== 'undefined') {
                    this.vatAmount = totalPrice - vatExclusivePrice
                }

                return vatExclusivePrice
            }
            if(this.isTermMonthly()){
                return result.total_price_monthly
            }
            return result.total_price
        },
        apiGetCalculation(id, data = null) {
            let requestData

            if (id === null || id === undefined) {
                return;
            }

            if(data !== null) {
                requestData = {...data} //cloning object otherwise it's a reference to VueX and it can't be mutated directly
                requestData.package = null
            }

			return this.$http
				.post(window.apiUrl + '/quote/' + id + '/calculate', requestData)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
        },
        initAdditonalPeople() {
            let peopleArr = this.$store.state.people
            if (!peopleArr) {
                return
            }

            this.form.people = peopleArr
        },
        initCoverType(){
            const coverType = this.$store.state.quote.cover_type
            if (!coverType) {
                return
            }
            this.form.cover_type.value = coverType
        },
        async initCustomer(detailsComponentRef, isCoverpage = false) {
            // isCoverpage is used to skip postcode lookup if true
            const customer = this.$store.state.customer
            if (!customer) {
                return
            }

            this.form.name.value = customer.firstname
            this.form.surname.value = customer.surname

            if (customer.dob && this.form.dateOfBirth) {
                const dateOfBirth = this.$moment(customer.dob)
                this.form.dateOfBirth.year.value = dateOfBirth.format('YYYY')
                this.form.dateOfBirth.month.value = dateOfBirth.format('M')
                this.form.dateOfBirth.day.value = dateOfBirth.format('D')
            } else if ( customer.dateOfBirth && this.form.dateOfBirth) {
                this.form.dateOfBirth.year.value = customer.dateOfBirth.year.value
                this.form.dateOfBirth.month.value = customer.dateOfBirth.month.value
                this.form.dateOfBirth.day.value = customer.dateOfBirth.day.value
            }

            this.form.email.value = customer.email
            this.form.phone.value = customer.phone

            if (customer.postcode && customer.postcode.length) {
                this.form.address.postcode.value = customer.postcode
                if(!isCoverpage) {
                    await this.lookupPostcode(this.form.address, 'postcode', detailsComponentRef)
                }
                this.prefillAddressDropdown(customer)
            }

            this.form.address.line1.value = customer.address_line_1

            if (customer.city) {
                this.form.address.town.value = customer.city
            }

            if (customer?.address_line_2) {
                this.form.address.line2.value = customer.address_line_2
            }

            if (customer?.address_line_3) {
                this.form.address.line3.value = customer.address_line_3
            }

            if (this.isBusinessFlow()) {
                this.form.address.type = {value: 'PRIMARY'}
            }
        },
        async initBusinessAccount() {
            const businessAccount = this.$store.state.business_account
            if (!businessAccount) {
                return
            }
            this.form.businessName.value = businessAccount.name
            this.form.businessPurpose.value = businessAccount.purpose
            this.form.named_contact.value = businessAccount.named_contact
            this.form.vat_number.value = businessAccount.vat_number

        },
        async initBillingAddress() {
            if (!this.$store.state.business_addresses) {
                return
            }
            const billingAddress = this.$store.state.business_addresses.find(item => item.type === 'BILLING')

            this.form.billingAddress = {
                postcode: {
                    value: null,
                },
                line1: {value: null},
                line2: {value: null},
                line3: {value: null},
                town: {value: null},
                county: {value: null},
                type: {value: null},
                manual: false,
                results: null,
                selectedResult: null,
                value: null,
            }

            if (billingAddress) {
                this.form.billingAddressIsDifferent.value = true
                this.form.billingAddress.postcode.value = billingAddress.postcode
                this.form.billingAddress.line1.value = billingAddress.line_1
                this.form.billingAddress.line2.value = billingAddress.line_2
                this.form.billingAddress.line3.value = billingAddress.line_3
                this.form.billingAddress.town.value = billingAddress.town
                this.form.billingAddress.type.value = billingAddress.type
            }
		},
		async initAvailableServices(reqType) {
			if (this.$store.state.available_services.length && reqType == 'cover') {
				return
			}
			const servicesResponse = await this.apiGetServices()
			if (!servicesResponse) {
				return
			}
			if (!servicesResponse.services) {
				return
			}
			await this.$store.commit(
				'SET_AVAILABLE_SERVICES',
				servicesResponse.services
			)
		},
		getServiceBySlug(slug) {
			if (!this.available_services || !this.available_services.length) {
				return null
			}
			return this.available_services.find((item) => {
				return item.slug === slug
			})
		},
		getDefaultQuoteObject() {
			return {
				home: null,
				nationwide: null,
				local: 0,
				personal: null,
				onward: null,
				misfuel:  null,
				excess: 1,
				accident: 1,
                accident_plus: 0,
                european: 0,
                parts_labour: 0,
                caravan_trailer: 0,
                key: 0,
                battery: null,
                tyre: null,
                no_people: 0
            }
		},

		setAppliedCoupon(couponObj) {
            const { value, discount, discountType } = couponObj
			this.coupon = {
				value: value.toUpperCase(),
				success: true,
				message: 'Discount code ' + value.toUpperCase() + ' applied!',
				hide: false,
                discount: discount,
                discountType: discountType
			}
		},

		prefillAddressDropdown(customer) {
			if (!this.form.address.results) {
				return
			}
			if (!this.form.address.results.length) {
				return
			}
			const addressPieces = [
				customer.address_line_1,
				customer.address_line_2,
				customer.address_line_3,
				customer.city,
			]
			const addressString = addressPieces.filter(Boolean).join(', ')

			const addressResultsFlat = this.form.address.results.map((item) => {
				return item.label
			})

			const matches = stringSimilarity.findBestMatch(
				addressString,
				addressResultsFlat
			)
			if (typeof matches.bestMatchIndex === 'undefined') {
				return
			}

			const addressBestMatch = this.form.address.results[matches.bestMatchIndex]
			if (typeof addressBestMatch === 'undefined') {
				return
			}

			this.form.address.value = addressBestMatch.value
			this.selectAddress()
		},
		prepareQuoteRequestData() {
            let data = {
				quote: this.quote,
				vehicles: this.vehicles,
				policy_start_date: this.policy_start_date,
				customer: this.customer,
                referrer_id: this.form.referrerId,
                buyapowa_voucher_code: this.form.buyapowaVoucherCode,
			}

            if (!this.isBusinessFlow()) {
                return data
            }

            data.business_account = this.business_account
            data.business_addresses = this.business_addresses

            return data
        },
        //todo: delete this as it doesnt work (no App name)
        gaEventFire(screenName) {
            gtag('event', 'screen_view', {
                'screen_name': screenName
            })
        },
        apiApplyCoupon(code) {
            return this.$http.post(window.apiUrl + '/quote/' + this.quote.id + '/coupon', {
                    coupon: code,
                    toggles: this.quote
                })
                .then(r => {
                    return r.data
                })
                .catch(e => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
                    return null
                })
        },
		apiRemoveCoupon() {
			return this.$http
				.post(window.apiUrl + '/quote/' + this.quote.id + '/remove-coupon', {
					toggles: this.quote,
				})
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
        getEmptyVehicle() {
            return {
                vrm: { value: null },
                make: { value: null },
                model: { value: null },
                year: { value: null },
                class: { value: null },
			}
		},
        getEmptyPeopleInfo() {
            return {
                name: {
                    value: null
                },
                surname: {
                    value: null
                },
                dateOfBirth: {
                    day: {
                        value: '',
                        options: [],
                    },

                    month: {
                        value: '',
                        options: [],
                    },
                    year: {
                        value: '',
                        options: [],
                    },
                },
                phone: {
                    value: null
                },
			}
        },
		addEmptyVehicle(key) {
            if (this.toggleManualVehicle(key)) {
                this.updateManualVehicle(key)
            }
			this.form.vehicles.push(this.getEmptyVehicle())
		},
        manuallySaveVehicle(manualVehicleArray) {
            this.form.vehicles = manualVehicleArray
        },
		removeVehicle(key) {
			this.form.vehicles.splice(key, 1)
		},
        isBusinessFlow() {
            return window.isBusiness
        },
        ageValidator(dateOfBirth, validAgeValue) {

            const day = dateOfBirth.day.value;
            const month = dateOfBirth.month.value;
            const year = dateOfBirth.year.value;


            this.isAllDateFieldsFilled = day && month && year;

            if (this.isAllDateFieldsFilled) {
                const birthDate = new Date(year, month - 1, day);
                const today = new Date();

                let age = today.getFullYear() - birthDate.getFullYear();

                if (today.getMonth() < birthDate.getMonth() ||
                    (today.getMonth() === birthDate.getMonth() &&
					today.getDate() < birthDate.getDate())) {
                    age -= 1;
                }
                validAgeValue = age >= 17;
                return validAgeValue;
            }
            return false;
        },
        dateValidator(dateOfBirth) {
            const day = dateOfBirth.day.value;
            const month = dateOfBirth.month.value;
            const year = dateOfBirth.year.value;

            if (day && month && year >= 1900) {
                const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

                let isLeapYear = this.$moment([year]).isLeapYear();
                if (isLeapYear) monthLength[1] = 29;

                if (month < 1 || month > 12) {
                    return false;
                }

                if (day < 1 || day > monthLength[month - 1]) {

                    return false;
                }

                const inputDate = this.$moment({ year, month: month - 1, day });
                const today = this.$moment();

                if (inputDate.isAfter(today, 'day')) {
                    return false;
                }

                return true;
            } else {
                return false;
            }
        },
        isTermMonthly() {
            if(this.quote && this.quote.package){
                return this.quote.package.subscription_term === 'month'
            }
            if(!window.package){
                return false
            }
            if(!window.package.subscription_term){
                return false
            }
            return window.package.subscription_term.toLowerCase() === 'month'
        },
        getVatExclusivePrice(grossPrice) {
            return Math.round(grossPrice / 1.2)
        },
        isVan(vehicle) {
            if (!vehicle || !vehicle.class) {
                return false
            }
            if (vehicle?.class.toLowerCase() === 'lcv' || vehicle?.class.toLowerCase() === 'hcv') {
                return true
            }
            return false
        },
        isHeavy(vehicle){

            if (vehicle?.make === 'SAAB') {
                return false
            }

            return vehicle?.weight > 3500 || vehicle?.grossWeight > 3500;
        },

        /**
         * This checks whether the vehicle is a taxi
         * Using an array of makes that we know as a taxi
         * @param {Object} vehicle - The vehicle that was retrieved
         * @returns {boolean} - Whether the vehicle found is a taxi or not
         */
        isVehicleATaxi(vehicle){
            // Guard clause for checking if the object has the property make
            if(vehicle && !vehicle.hasOwnProperty('make'))
            {
                return false;
            }

            // Guard clause for if the make doesn't exist
            if(!vehicle.make)
            {
                return false;
            }

            // Array of all the taxi makes from UK Data Vehicle API response
            const taxiMakes = ["LTI VRS TX4 LPG", "LONDON TAXIS INT", "LEVC", "ECOTIVE METROCAB"]

            if (taxiMakes.includes(vehicle.make.toUpperCase())) {
                return true
            }

            // Regex for word = "taxi"
            const taxiRegex = /taxi/i

            // Checking if taxiRegex is included within vehicle make and mdoel
            if (
                (vehicle.model && taxiRegex.test(vehicle.model)) ||
                (vehicle.make && taxiRegex.test(vehicle.make))
            ) {
                return true
            }

            return false
        },
        apiLogQuoteUserAcquisition(data) {
			return this.$http
				.post(window.apiUrl + '/quote-user-acquisitions', data)
				.then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},
        prepareCouponCode(code) {
            return code.replace(' ', '').toUpperCase()
        },
        prepareVrm(vrm) {
            return vrm.replace(' ', '').toUpperCase()
        },
        sendGaEvent(action, category, label, value = null){
            let eventData = {
              'event_category': category,
              'event_label': label,
            }

            if(value){
                eventData.value = value
            }
            if(typeof gtag === 'undefined'){
                return
            }
            gtag('event', action, eventData);
        },
        sendFacebookLead()
        {
            if(typeof window.fbq === 'undefined'){
                return
            }
            window.fbq('track','Lead')
        },
        sendGaPageview(path)
        {
            if(typeof gtag === 'undefined'){
                return
            }
            if(!path){
                path = window.location.pathname
            }
            gtag('set', 'page_path', path)
            gtag('event', 'page_view')
        },
        sendBingPageview(path = null)
        {
            if(!path){
                path = window.location.pathname
            }
            window.uetq = window.uetq || [];
            window.uetq.push('event', 'page_view', { 'page_path': path });
        },
        sendGoogleAdsConversion(sendTo)
        {
            if(typeof gtag === 'undefined'){
                return
            }
            gtag('event', 'conversion', {'send_to': sendTo })
        },
        setPriceFromApiResult(result){
            if (this.isBusinessFlow()) {
                this.price = this.getVatExclusivePrice(result.total_price)

                if(this.isTermMonthly()){
                    this.price = this.getVatExclusivePrice(result.total_price_monthly)
                    this.vatAmount = result.total_price_monthly - this.price
                } else {
                    this.vatAmount = result.total_price - this.price
                }
                return
            }

            if (typeof this.preDiscountPrice !== 'undefined') {
                if (result && result.pre_discount) {
                    this.preDiscountPrice = result.pre_discount
                }
            }

            if (typeof this.partsAndLabourPrice !== 'undefined') {
                this.partsAndLabourPrice = 0
                if (result && result.total_parts_labour) {
                    this.partsAndLabourPrice = result.total_parts_labour
                }
            }

            if(this.isTermMonthly()){
                this.price = result.total_price_monthly
                return
            }

            this.price = result.total_price
        },
        initDefaultServices(){
            // included as standard
            this.form.roadside.value = 1
            this.form.local.value = 1
            this.form.accident.value = 1
            // no longer offered effective Jul 22
            this.form.excess.value = 0
        },
        sendHotjarIdentifier(quoteId, quoteData = null)
        {
            window.hj=window.hj||function(){(hj.q=hj.q||[]).push(arguments)};
            if(typeof window.hj === 'undefined'){
                return
            }

            let customAttributes = {}
            if(quoteData.package_id){
                customAttributes.package_id = quoteData.package_id
            }
            window.hj('identify', quoteId, customAttributes);

        },
        apiTogglePackageTerm(term, packageId) {
			return this.$http
                .post(window.apiUrl + '/quote/' + this.quote.id + '/toggle-package', {
                    term: term,
                    package_id: packageId,
                })
                .then((r) => {
					return r.data
				})
				.catch((e) => {
                    Bugsnag.notify(new Error('API Request Failed'), event => {
                        event.addMetadata('Axios Error', this.parseAxiosErrors(e));
                    });
					return null
				})
		},

        disableButtonSaveNote() {
            document.getElementById('save-note-button').innerHTML = 'Saving...';
            document.getElementById('save-note-button').style.pointerEvents = 'none';
        },


	},

    mounted() {}})

Vue.filter('toCurrency', function(value) {
	if (typeof value !== 'number') {
		return value
	}
	value = value / 100
	const formatter = new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: 2,
	})
	return formatter.format(value)
})

window.Vue = Vue

// Add global unhandled promise rejection handler
window.addEventListener('unhandledrejection', event => {
    console.error('Unhandled promise rejection:', event.reason);

    if(window.bugsnag) {
        window.bugsnag.notify(new Error("Unhandled Promise Rejection error"), (event) => {
            event.severity = "warning";
            event.addMetadata("new unhandled promise rejection", event.reason);
        })
    }
});
